'use strict';
import axios from 'axios';
import ENV from '../environtment'

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getZoneMasterByCompany(context, params = {}) {
    const defaultData = {rows: [], count: 0}
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/zonemaster/listbycompanyid`
        const result = await axios.get(url, {
          ...costumHeader('Get Zone Master by Company', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  getMutationZones(context, params = {}) {
    const defaultData = {records: []}
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/zonemaster/historical`
        const result = await axios.get(url, {
          ...costumHeader('Get Zone Master by Company', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) return resolve(result.data.data)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(defaultData)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(defaultData)
      }
    })
  },
  saveZoneMaster(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/zonemaster/add`
        const result = await axios.post(url, body, costumHeader('Save Zone Master', 1))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  editZoneMaster(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/zonemaster/edit`
        const result = await axios.post(url, body, costumHeader('Edit Zone Master', 2))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  },
  deleteZoneMaster(context, body = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/zonemaster/delete`
        const result = await axios.post(url, body, costumHeader('Delete Zone Master', 3))
        if (result) if (result.data) if (result.data.code == 200) return resolve(true)
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve(false)
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve(false)
      }
    })
  }
}

export default { actions }